import { render } from "./SearchSwitcherDefaultIcon.vue?vue&type=template&id=77a5718c"
const script = {}

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__